import React, { FC, useState } from "react";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import MainClientInfo from "./components/MainClientInfo";
import ClientOrdersHistory from "./components/ClientOrdersHistory";
import ClientSettings from "./components/ClientSettings";
import ConfirmModal from "components/ConfirmModal";
import { IProfileProps } from "./types";
import { profileTabs, tabValues } from "./constants";
import ClearIcon from "@mui/icons-material/Clear";
import useIsMobile from "hooks/useIsMobile";
import { signOut } from "store/slices/auth";
import { useAppDispatch } from "store/hooks/useAppDispatch";
import { useAppSelector } from "store/hooks/useAppSelector";
import { shallowEqual } from "react-redux";
import styles from "./Profile.styled";

const Profile: FC<IProfileProps> = ({ isOpen, onClose }) => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const accentColor = useAppSelector(
    (state) => state.settings.config.accentColor,
    shallowEqual,
  );
  const isMobile = useIsMobile();
  const dispatch = useAppDispatch();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleLogOut = () => {
    dispatch(signOut());
    setIsConfirmModalOpen((prev) => !prev);
    onClose();
  };

  const handleToggleConfirmModal = () => setIsConfirmModalOpen((prev) => !prev);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      sx={styles.drawer(isConfirmModalOpen)}
    >
      <Box sx={styles.drawerContent}>
        {isMobile && (
          <IconButton onClick={onClose} sx={styles.closeIcon}>
            <ClearIcon />
          </IconButton>
        )}
        <Typography variant="h2">Особистий кабінет</Typography>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          scrollButtons={false}
          variant="scrollable"
          sx={styles.tabs(accentColor)}
        >
          {profileTabs.map((tab) => (
            <Tab label={tab.label} key={tab.id}></Tab>
          ))}
        </Tabs>
        {tabValue === tabValues.mainInfo && (
          <>
            <MainClientInfo />
            {!isMobile && (
              <Button
                type="button"
                className="secondary"
                sx={styles.btn}
                onClick={handleToggleConfirmModal}
              >
                Вийти
              </Button>
            )}
          </>
        )}
        {tabValue === tabValues.history && (
          <ClientOrdersHistory onAction={onClose} />
        )}
        {tabValue === tabValues.settings && <ClientSettings />}
        <ConfirmModal
          openModal={isConfirmModalOpen}
          modalClose={handleToggleConfirmModal}
          handleAction={handleLogOut}
          titleMessage="Ви дійсно хочете вийти?"
          buttonMessage="Так"
          secondBtnMessage="Ні"
        />
      </Box>
    </Drawer>
  );
};

export default Profile;
